import { ConfigProvider } from 'antd';
import { LazyMotion, MotionConfig } from 'motion/react';
import React from 'react';
import { Provider } from 'react-redux';
import { recordPageLoad } from 'library/helpers/reloadLoopGuard';
import ReloadLoop from 'publicContainer/ReloadLoop';
import Boot from 'reduxStore/boot';
import { store } from 'reduxStore/store';
import GlobalStyles from 'theme/globalStyles';
import themeConfig from 'theme/mainDashboard.json';
import { DURATION, EASE } from 'theme/motion';
import Navigation from './Navigation/index';

const { componentSize, ...theme } = themeConfig;

// Animation features load in their own chunk. LazyMotion `strict` allows only the light `m.*`
// components — `motion.*` would pull the full engine into the main bundle.
const loadMotionFeatures = () => import('theme/motionFeatures').then((mod) => mod.default);

// A tab caught reloading itself does not boot: no auth check, no routes, no API calls — see
// library/helpers/reloadLoopGuard. Decided once per page load, before Boot.
const { tripped: reloadLoop } = recordPageLoad();
if (reloadLoop) console.warn('[reloadLoopGuard] this tab keeps reloading; boot paused');

const App = () => (
	<Provider store={store}>
		<ConfigProvider theme={theme} componentSize={componentSize}>
			<LazyMotion features={loadMotionFeatures} strict>
				<MotionConfig reducedMotion='user' transition={{ duration: DURATION.base, ease: EASE.out }}>
					<GlobalStyles />
					{reloadLoop ? <ReloadLoop /> : <Navigation />}
				</MotionConfig>
			</LazyMotion>
		</ConfigProvider>
	</Provider>
);
if (!reloadLoop) {
	Boot()
		.then(() => App())
		.catch((error) => console.error(error));
}

export default App;
